import React from 'react';
const Loader: React.FC = () => {
  return <div className="absolute inset-0 !z-[500] flex h-full items-center justify-center bg-white bg-opacity-50" data-sentry-component="Loader" data-sentry-source-file="loader.tsx">
      <div className="h-6 w-6 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
    </div>;
};
export { Loader };